import { forwardRef } from 'react';

import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  useGridRootProps,
  type GridToolbarProps,
} from '@mui/x-data-grid-pro';

// Note: Copy of https://github.com/mui/mui-x/blob/master/packages/x-data-grid/src/components/toolbar/GridToolbar.tsx
export const GridToolbar = forwardRef<HTMLDivElement, GridToolbarProps>(
  function GridToolbar(props, ref) {
    const {
      className,
      csvOptions,
      printOptions,
      excelOptions,
      showQuickFilter = false,
      quickFilterProps = {},
      ...other
    } = props as typeof props & { excelOptions: any };
    const rootProps = useGridRootProps();

    if (
      rootProps.disableColumnFilter &&
      rootProps.disableColumnSelector &&
      rootProps.disableDensitySelector &&
      !showQuickFilter
    ) {
      return null;
    }

    return (
      <GridToolbarContainer {...other} ref={ref}>
        {showQuickFilter && <GridToolbarQuickFilter {...quickFilterProps} />}
        <div style={{ flex: 1 }} />
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={csvOptions}
          printOptions={printOptions}
          // @ts-expect-error duplicate fix from mui
          excelOptions={excelOptions}
        />
      </GridToolbarContainer>
    );
  },
);
